import axios from 'axios'
import Vue from 'vue'

import { apiUrl } from '@/config';
import LocalStorage from '@/utils/LocalStorage';
import { STORE_AUTH_TOKEN } from '@/AppKeys';
import i18nPlugin from './i18n';

const axiosInstance = axios.create({
  baseURL: apiUrl,
  headers: {
    'Content-Type': 'application/json'
  }
});

// Add a request interceptor
axiosInstance.interceptors.request.use((axiosconfig) => {
  axiosconfig.headers.Locale = i18nPlugin.locale || 'en';
  if (LocalStorage.get(STORE_AUTH_TOKEN)) {
    axiosconfig.headers.authorization = 'Bearer ' + LocalStorage.get(STORE_AUTH_TOKEN);
  }
  return axiosconfig;
}, (error) => {
  console.log('AXIOS:INTERCEPTORS:: Request error', error);
  // Do something with request error
  return Promise.reject(error);
});

// Add a response interceptor
axiosInstance.interceptors.response.use((response) => {

  return response;
}, (error) => {

  console.log("Error occured", error.response);
  if (error.response && error.response.status !== 422 && error.response.data) {
    Vue.prototype.$app.toast(error.response.data.message, 5000, "error");
  }

  if (error.response) {
    return Promise.reject(error.response);
  }
  return Promise.reject(error);
});

Vue.prototype.$axios = axiosInstance;

export const axiosProxy = axiosInstance;

